import { Dispatch, SetStateAction } from 'react';

import { Button, Modal } from '@components/index';

export const RemoveLabelConfirmationModal = ({
  isOpen,
  setIsOpen,
  handleConfirmRemove,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  handleConfirmRemove: () => void;
}) => {
  const handleRemove = () => {
    handleConfirmRemove();
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="px-6 py-8 w-[620px] flex flex-col gap-2">
        <div className="text-lg font-medium">Confirm Label Removal</div>
        <span className="text-gray-8">
          You are about to remove all labels - please confirm.
        </span>
      </div>
      <div className="justify-center flex mb-8 space-x-4">
        <Button
          label="No, cancel"
          onClick={() => setIsOpen(false)}
          classOverride="!w-[260px] !border-gray-4 !text-gray-9 !font-medium"
        />
        <Button
          label="Yes, remove"
          classOverride="!w-[260px] !border-red-3 !bg-red-3 !text-white"
          onClick={handleRemove}
        />
      </div>
    </Modal>
  );
};
